import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import settings from '../../config/settings';
import * as BrowserUtils from '../utils/BrowserUtils';
import EmbedVideo from './EmbedVideo';
import * as CardUtils from '../utils/CardUtils';
import {injectHtml} from '../utils/DomUtils';
import {cardLoadMode} from '../const/VuCardConst';

export default class VuCardLargeVideoWithCTA extends React.Component {
  constructor() {
    super();

    this.state = {
      isMobile: false
    };

    this.getPreviewConfig = this.getPreviewConfig.bind(this);
    this.onCardClick = this.onCardClick.bind(this);
  }

  componentDidMount() {
    this.setState({isMobile: BrowserUtils.isMobile.any()});

    this.applyCallToAction();
  }

  applyCallToAction() {
    const {callToAction} = this.props.record;

    if (callToAction) {
      const wrapper = document.createElement('span');
      this.callToActionContainer.appendChild(wrapper);
      injectHtml(wrapper, callToAction);
    }
  }

  render() {
    const {record} = this.props;
    const previewConfig = this.getPreviewConfig();

    if (!record) {
      return null;
    }

    let contentStyle = null;
    if (_.get(record, 'backgroundColor')) {
      contentStyle = {backgroundColor: record.backgroundColor};
    }

    return (
      <div className="vuCard__content"
           onClick={this.onCardClick}
           style={contentStyle}>
        <div className="vuCard__content__movie">
          {
            (previewConfig.videoUrl || previewConfig.videoImg) ?
              <div className="vuCard__content__movie__video">
                {this.renderPreviewVideo(previewConfig)}
              </div>
              : null
          }
          {
            previewConfig.posterUrl ?
              <div className="vuCard__content__movie__cover">
                <img src={previewConfig.posterUrl}/>
              </div>
              : null
          }
        </div>
        {
          this.setCustomStylesForCta()
        }
        {
          this.renderCta()
        }
      </div>);
  }

  setCustomStylesForCta() {
    const {callToActionColor} = this.props.record;

    if (callToActionColor) {
      return (
        <style dangerouslySetInnerHTML={{
          __html: `
.vuCard__content__cta {
  color: ${callToActionColor};
}
`
        }} />
      );
    }
  }

  renderCta() {
    return (
      <div className="vuCard__content__cta"
        ref={(node) => {
          this.callToActionContainer = node;
        }}
      />);
  }

  getPreviewConfig() {
    const {record, mode} = this.props;
    const posterUrl = CardUtils.getHorizontalPosterImageUrl(record);
    const videoUrl = CardUtils.getPosterVideoUrl(record);
    const videoImg = posterUrl;

    if (mode === cardLoadMode.preview && record.isVideoPreviewBlocked) {
      return {
        videoUrl,
        videoKind: 'upload',
        videoImg: _.get(settings, 'create.logoUrl', '/static/logo.png')
      };
    }

    return videoUrl ? {
      videoUrl,
      videoKind: record.posterVideo.kind,
videoImg
    } : {posterUrl};
  }

  renderPreviewVideo(config) {
    if (!this.props.isVisible) return null;

    return (
      <EmbedVideo url={config.videoUrl}
                  onPlayerClick={this.onVideoPlayerClick.bind(this)}
                  kind={config.videoKind}
                  poster={config.videoImg}/>);
  }

  onVideoPlayerClick() {
    this.openActionUrl();
  }

  onCardClick() {
    this.openActionUrl();
  }

  openActionUrl() {
    const actionUrl = _.get(this.props, 'renderer.actionUrl');
    if (actionUrl) {
      window.open(actionUrl, '_blank');
    }
  }
}

VuCardLargeVideoWithCTA.propTypes = {
  record: PropTypes.object.isRequired,
  mode: PropTypes.oneOf(Object.values(cardLoadMode)),
  renderer: PropTypes.object
};

VuCardLargeVideoWithCTA.defaultProps = {
};
